import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "absolute z-10 top-0 left-0 right-0 bottom-0 flex items-center justify-center py-20 bg-white rounded-xl p-6"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Data is out of date, please apply the filters", -1)
const _hoisted_3 = [
  _hoisted_2
]

import { useFilterStore } from "@/stores/filterStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'FiltersOutOfDateComponent',
  setup(__props) {

const filterStore = useFilterStore();

return (_ctx: any,_cache: any) => {
  return (_unref(filterStore).filtersChanged === true)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : _createCommentVNode("", true)
}
}

})